module.exports = __webpack_public_path__ + "static/assets/b46e0ae877de42554ae321fb4e9ce420.png";